import angular from 'angular';
import template from './mobile-preview-actions.html';
import * as call from '../../../../../modules/call';
class MobilePreviewActionsController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
    }
    hidePreview() {
        this.$ngRedux.dispatch(call.actions.hideSelfPreview());
    }
}
const mobilePreviewActions = {
    template,
    bindings: {
        hasVideo: '<',
        hasAudio: '<',
        onToggleVideo: '&',
        onToggleAudio: '&',
        onSwitchCamera: '&',
        isSwitchCameraAvailable: '<',
    },
    controller: MobilePreviewActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrameMiniComponent.mobilePreviewActions', [])
    .component('mobilePreviewActions', mobilePreviewActions).name;
